import React from 'react';
import { Image } from 'antd';
const ImageComp = ({url, width, height}) => (
  <Image
    width={width}
    height={height}
    src={url}
  />
);
export default ImageComp;